import styled from 'styled-components';
import { Button, Card } from 'antd';

export const PageContainer = styled.div`
  width: 100%;
  padding: 25px;
  overflow: hidden;

  .ant-table-wrapper {
    margin-top: 25px;
    overflow-x: scroll;
  }

  .ant-card-body {
    width: 100%;
  }
`;

export const StyledCard = styled(Card)`
  width: 100%;

  .ant-card-head-title {
    font-size: 18px;
    font-weight: 600;
  }
`;

export const FiltersRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 20px;
  align-items: flex-end;
`;

export const ButtonsRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-bottom: 20px;
`;

export const TabsContainer = styled.div`
  margin-bottom: 20px;
`;

export const StatusBadge = styled.span`
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  background-color: ${props => {
    switch (props.status) {
      case 'available': return '#e6f7e6';
      case 'checked_out': return '#fff7e6';
      case 'maintenance': return '#e6f0ff';
      case 'retired': return '#f5f5f5';
      default: return '#f5f5f5';
    }
  }};
  color: ${props => {
    switch (props.status) {
      case 'available': return '#52c41a';
      case 'checked_out': return '#faad14';
      case 'maintenance': return '#1890ff';
      case 'retired': return '#8c8c8c';
      default: return '#8c8c8c';
    }
  }};
`;

export const ModalContent = styled.div`
  padding: 20px 0;
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const FormRow = styled.div`
  margin-bottom: 16px;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 6px;
  font-weight: 500;
  color: #333;
`;

export const SettingsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
`;

export const SettingCard = styled.div`
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 16px;
  background: #fafafa;
`;

export const SettingTitle = styled.div`
  font-weight: 500;
  margin-bottom: 8px;
`;

export const SettingDescription = styled.div`
  font-size: 12px;
  color: #666;
  margin-bottom: 12px;
`;
